/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Practice_Session_Status_SpeakingInputs */



/**
* | output |
* | --- |
* | "{name} is speaking" |
*
* @param {Practice_Session_Status_SpeakingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_status_speaking = /** @type {((inputs: Practice_Session_Status_SpeakingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Status_SpeakingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} spreekt`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} parle`)
	return /** @type {LocalizedString} */ (`${i?.name} is speaking`)
});